import React, { useState } from 'react';

const StudentAccommodation = () => {
  const [accommodations, setAccommodations] = useState([
    { id: 1, name: 'John Doe', phone: '(555) 333-7890', email: 'alex.j@example.com', property: 'University Heights Apt', duration: '6 months', status: 'Confirmed' },
  ]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [newAccommodation, setNewAccommodation] = useState({
    name: '',
    email: '',
    phone: '',
    property: '',
    duration: '',
    status: 'Pending'
  });

  const handleInitiateBooking = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setNewAccommodation({
      name: '',
      email: '',
      phone: '',
      property: '',
      duration: '',
      status: 'Pending'
    });
  };

  const handleAddAccommodation = () => {
    // Validate form
    if (!newAccommodation.name || !newAccommodation.email || !newAccommodation.phone || !newAccommodation.property || !newAccommodation.duration) {
      alert('Please fill in all required fields');
      return;
    }
    
    // Add new accommodation to the list
    const newAccommodationWithId = {
      id: accommodations.length + 1,
      ...newAccommodation
    };
    
    setAccommodations([...accommodations, newAccommodationWithId]);
    closePopup();
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-[#02385E] font-Montserrat">Student Accommodation Services</h1>
        <button
          onClick={handleInitiateBooking}
          className="px-4 py-2 text-white font-semibold rounded-full flex items-center gap-2"
          style={{ background: 'linear-gradient(180deg, #FFA782 0%, #FC583D 100%)', }}  >
          <span style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '500', lineHeight: '24.38px', }}>            
            Book Accommodation
          </span>
          <img src={`${process.env.PUBLIC_URL}/images/desktop/staffadd.svg`} alt="Add Booking Icon" className="w-4 h-4 ml-2" />
        </button>
      </div>

      <div className="rounded-xl overflow-hidden bg-white shadow-lg">
        <div className="overflow-x-auto relative">
          <table className="min-w-full table-auto border-collapse">
            <thead>
              <tr className="bg-gradient-to-r from-[#02385E] to-[#02385E]/90">
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Name</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Phone</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Email</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Property</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Duration</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {accommodations.map((accommodation, index) => (
                <tr key={accommodation.id} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={accommodation.name}>{accommodation.name}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={accommodation.phone}>{accommodation.phone}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={accommodation.email}>{accommodation.email}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={accommodation.property}>{accommodation.property}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={accommodation.duration}>{accommodation.duration}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <span className={`inline-block min-w-[80px] px-2 py-1 rounded-full ${
                      accommodation.status === 'Confirmed' ? 'bg-green-100 text-green-800' :
                      accommodation.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                      accommodation.status === 'Processing' ? 'bg-blue-100 text-blue-800' :
                      accommodation.status === 'Cancelled' ? 'bg-red-100 text-red-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {accommodation.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Accommodation Booking Popup */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-3xl w-[90%] md:w-[70%] lg:w-[50%] relative">
            <div className="top-0 left-0 right-0 h-[40px] flex items-center justify-between rounded-tl-[12px] rounded-tr-[12px] p-4">
              <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-gradient-to-b from-[#00A6D9] to-[#3483BE] flex items-center justify-center">
                  <img src={`${process.env.PUBLIC_URL}/images/desktop/ph_student.svg`} alt="Student Icon" />
                </div>
                <h2 className="text-xl font-semibold text-black">Book Student Accommodation</h2>
              </div>
              <div className="text-right">
                <button onClick={closePopup} className="absolute top-4 right-4 font-semibold text-3xl" style={{ background: 'linear-gradient(270deg, #A7C8E7 0%, #00A6D9 100%)', WebkitBackgroundClip: 'text', color: 'transparent', }}>
                  <img src={`${process.env.PUBLIC_URL}/images/desktop/close-btn.svg`} alt="Close" className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mt-8">
              <div>
                <label className="block text-sm font-medium text-gray-700">Name <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Student Name"
                  value={newAccommodation.name}
                  onChange={(e) => setNewAccommodation({ ...newAccommodation, name: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={newAccommodation.email}
                  onChange={(e) => setNewAccommodation({ ...newAccommodation, email: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Phone <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Phone Number"
                  value={newAccommodation.phone}
                  onChange={(e) => setNewAccommodation({ ...newAccommodation, phone: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Property <span className="text-red-500">*</span></label>
                <select
                  value={newAccommodation.property}
                  onChange={(e) => setNewAccommodation({ ...newAccommodation, property: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                >
                  <option value="">Select Property</option>
                  <option value="University Heights Apt">University Heights Apt</option>
                  <option value="Campus View Residence">Campus View Residence</option>
                  <option value="Scholar's Lodge">Scholar's Lodge</option>
                  <option value="Academic Commons">Academic Commons</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Duration <span className="text-red-500">*</span></label>
                <select
                  value={newAccommodation.duration}
                  onChange={(e) => setNewAccommodation({ ...newAccommodation, duration: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                >
                  <option value="">Select Duration</option>
                  <option value="3 months">3 months</option>
                  <option value="6 months">6 months</option>
                  <option value="9 months">9 months</option>
                  <option value="12 months">12 months</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Status</label>
                <select
                  value={newAccommodation.status}
                  onChange={(e) => setNewAccommodation({ ...newAccommodation, status: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                >
                  <option value="Pending">Pending</option>
                  <option value="Processing">Processing</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Expired">Expired</option>
                </select>
              </div>
            </div>

            <div className="mt-8 flex justify-end">
              <button 
                onClick={handleAddAccommodation} 
                className="px-8 py-2 bg-gradient-to-b from-[#FFA782] to-[#FC583D] text-white rounded-3xl"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentAccommodation;